declare global {
  interface Window {
    fbq?: (...args: any[]) => void
    _fbq?: any
  }
}

const PIXEL_ID = '1086059581265994'

export function initMetaPixel() {
  if (typeof window === 'undefined') return
  if (window.fbq) return // Standard Meta Pixel snippet
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      // eslint-disable-next-line prefer-rest-params
      n.callMethod
        ? // eslint-disable-next-line prefer-rest-params
          n.callMethod.apply(n, arguments as any)
        : // eslint-disable-next-line prefer-rest-params
          n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    s.parentNode?.insertBefore(t, s)
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )

  window.fbq?.('init', PIXEL_ID)
  window.fbq?.('track', 'PageView')
  // eslint-disable-next-line no-console
  console.info('[MetaPixel] init + PageView →', PIXEL_ID)
}

export function trackAddToCart() {
  if (typeof window === 'undefined') return
  const payload = {
    content_name: 'Metabolismo Silver 21',
    content_ids: ['metabolismo-silver-21'],
    content_type: 'product',
    value: 6.39,
    currency: 'USD',
  }
  window.fbq?.('track', 'AddToCart', payload)
  // eslint-disable-next-line no-console
  console.info('[MetaPixel] AddToCart →', payload)
}
